module.exports = __webpack_public_path__ + "img/layout-grid-02.4cd4ab6c.svg";